import { BaseError } from './base';

export function BLError(message, debug, code, kinveyRequestId) {
  this.name = 'BLError';
  this.message = message || 'The Business Logic script did not complete.';
  this.debug = debug || undefined;
  this.code = code || undefined;
  this.kinveyRequestId = kinveyRequestId || undefined;
  this.stack = (new Error()).stack;
}
BLError.prototype = Object.create(BaseError.prototype);
BLError.prototype.constructor = BLError;



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/errors/bl.js